export default __webpack_public_path__ + "static/media/Events.c3c5268e.svg";